import React from "react";
import {Box, Button, Icon} from "@material-ui/core";
import {Link} from "react-router-dom";

const ProfileButtons = ({
                          patient,
                          classes,
                          match,
                          location,
                          params,
                          onToggleActivationClick,
                        }) => {
  return (
    <>
      <Box>
        <Button
          className={classes.profileButton}
          variant="contained"
          color="primary"
          disableElevation={true}
          startIcon={<Icon>edit</Icon>}
          component={Link}
          to={{
            pathname: `${match.path.split(":")[0]}edit/${params.id}`,
            state: {
              orgIdHistory: location.state && location.state.orgIdHistory,
              orgNameHistory: location.state && location.state.orgNameHistory,
              deptIdHistory: location.state && location.state.deptIdHistory,
              deptNameHistory: location.state && location.state.deptNameHistory,
            },
          }}
        >
          Edit Details
        </Button>
      </Box>

      <Box>
        <Button
          variant="contained"
          color="primary"
          disableElevation={true}
          startIcon={
            patient.active === false ? (
              <Icon>check_circle_outline</Icon>
            ) : (
              <Icon>block</Icon>
            )
          }
          onClick={onToggleActivationClick}
          classes={{
            root: `${classes.profileButton} ${
              patient.active
                ? classes.blockButton
                : classes.activeButton
            }`,
          }}
        >
          {patient.active === false ? "Activate" : "Deactivate"}
        </Button>
      </Box>
    </>
  );
};

export default ProfileButtons;
